import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { QUOTEMEDIA_EOD_PRICE_JOB_BASE_PATH } from '../../../../../../../../../features/vendor/quotemedia/eod-price/job/quotemedia-eod-price-job-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/job/_job')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'quote-media-eod-price',
        label: 'QuoteMedia',
        to: QUOTEMEDIA_EOD_PRICE_JOB_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
